// extracted by mini-css-extract-plugin
module.exports = {"btn-container":"index__btn-container__ky9Fb","btn-cancel":"index__btn-cancel__UvD73","btn-confirm":"index__btn-confirm__3pBcK"};